import { render, staticRenderFns } from "./ReasonRejectStudentChangeRequest.vue?vue&type=template&id=48db48fc&"
import script from "./ReasonRejectStudentChangeRequest.vue?vue&type=script&lang=js&"
export * from "./ReasonRejectStudentChangeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports